export default __webpack_public_path__ + "static/media/Duffman.def2bddd.png";